module.exports = __webpack_public_path__ + "static/media/udaan.41c6e64d.png";


//////////////////
// WEBPACK FOOTER
// ./src/Skillset/icon/udaan.png
// module id = 85
// module chunks = 0